import React from 'react';
import SearchCard from './search_card'
import {Row} from "react-bootstrap";
import "./style/style.css"

function SearchList({ filteredAPI }) {
  const filtered = filteredAPI.map(api =>
      <SearchCard key={api.id} api={api} />);
  return (
    <Row className="search_list">
      {filtered}
    </Row>
  );
}

export default SearchList;